export default {
  confirm: 'Confirmer',
  cancel: 'Annuler',
  ok: 'OK',
  back: 'Retour',
  submit: 'Envoyer',
  retry: 'Réessayer',
  delete: 'Supprimer',
  close: 'Fermer',
  openInNewWindow: 'Ouvrir dans une nouvelle fenêtre',
  codeNotReceived: 'Code non reçu ?',
  forgotPassword: 'Mot de passe oublié ?',
  or: 'OU',
  disable: 'Désactiver',
  save: 'Enregistrer',
  login: 'Se Connecter',
  logout: 'Se déconnecter',
  edit: 'Modifier',
  unknownError: 'Une erreur est survenue',
  chooseLanguage: 'Choisir la langue',
  waitBeforeRetry: 'Veuillez attendre {timeRemaining} avant de réessayer',
  yes: 'Oui',
  no: 'Non',
  dontAsk: 'Ne plus demander'
}
